import $ from 'jquery'
import Splide from '@splidejs/splide'

const initializeBlock = function ($block) {
  var blockID = $block.attr('data-unique-id')
  var modalID = '#services-modal-' + blockID

  var splide = new Splide('.js-services-' + blockID, {
    perPage: 3,
    perMove: 1,
    gap: '30px',
    arrows: false,
    breakpoints: {
      992: {
        perPage: 2,
      },
      767: {
        perPage: 1,
      },
    },
  })

  var splideDetails = new Splide('.js-service-detail-' + blockID, {
    pagination: false,
    arrows: false,
  })

  var splideThumbnails = new Splide('.js-thumbnails-' + blockID, {
    rewind: true,
    fixedWidth: 105,
    fixedHeight: 105,
    isNavigation: true,
    gap: 20,
    focus: 'center',
    pagination: false,
    arrows: false,
  })

  splideDetails.sync(splide)
  splideDetails.sync(splideThumbnails)

  splideThumbnails.mount()
  splideDetails.mount()
  splide.mount()

  splide.on('click', function (Slide, e) {
    $(modalID).modal('show')

    $(modalID).on('shown.bs.modal', function () {
      splide.go(Slide.index)
      splideThumbnails.go(Slide.index)
      splideDetails.go(Slide.index)
    })
  })

  $('.js-remove-visible-slide').removeClass('is-visible')

  $('.js-close-services').on('click', function () {
    $(modalID).modal('hide')
  })
}

$('.services-block').each(function () {
  initializeBlock($(this))
})
